/* Filtros compartilhados pelas telas de análise (ano, obra e escopo). */

import type { Params } from '../core/api';
import { isApi } from '../core/config';
import { state } from '../core/estado';
import { esc } from '../core/formato';

export function paramsFiltro(extra: Params = {}): Params {
  const p: Params = { ano: state.f.ano };
  if (state.f.obra) p.id_unidade = state.f.obra;
  if (state.f.escopo) p.escopo = state.f.escopo;
  return Object.assign(p, extra);
}

/** Barra de filtros; cada select dispara a ação global "filtro" (ver roteador). */
export function filtrosBar({ escopo = false } = {}): string {
  const atual = new Date().getFullYear();
  const anos: number[] = [];
  for (let a = atual; a >= atual - 4; a--) anos.push(a);
  if (!anos.includes(Number(state.f.ano))) anos.push(Number(state.f.ano));
  const obras = state.cat?.obras || [];
  const empresa = state.cat?.empresa;
  return `<div class="filters no-print">
    <div class="field"><label>Ano</label><select class="inp" data-muda="filtro" data-chave="ano">${anos.map((a) => `<option ${Number(state.f.ano) === a ? 'selected' : ''}>${a}</option>`).join('')}</select></div>
    <div class="field" style="min-width:230px"><label>Obra</label><select class="inp" data-muda="filtro" data-chave="obra">
      <option value="">Todas as obras</option>${obras.map((o) => `<option value="${esc(o.id)}" ${o.id === state.f.obra ? 'selected' : ''}>${esc(o.nome)}</option>`).join('')}</select></div>
    ${escopo ? `<div class="field"><label>Escopo</label><select class="inp" data-muda="filtro" data-chave="escopo">
      <option value="">Todos</option>${[1, 2, 3].map((e) => `<option value="${e}" ${String(state.f.escopo) === String(e) ? 'selected' : ''}>Escopo ${e}</option>`).join('')}</select></div>` : ''}
    <span class="pill grey" style="margin-bottom:10px">${isApi() ? `${esc(empresa?.nome || '')} · ${esc(empresa?.versao_ghg || '')}` : 'Dados simulados'}</span>
  </div>`;
}
